export default function debounce<T extends Function> (func: T, timeout = 300) {
  let timer: number;
  return function(this: unknown, ...args: unknown[]) {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}